exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-authority{position:absolute;top:0;right:0;bottom:0;left:0;display:flex;justify-content:center;align-items:center;background-color:hsla(0,0%,98.4%,.9);z-index:999;-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);border-radius:inherit}.no-authority .no-authority-text{text-align:center;color:#767b83;line-height:18px}", ""]);

// exports
